var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4109 5.73041C13.6921 5.44924 14.1479 5.44924 14.4291 5.73041L20.1891 11.4904C20.4703 11.7716 20.4703 12.2275 20.1891 12.5086L14.4291 18.2686C14.1479 18.5498 13.6921 18.5498 13.4109 18.2686C13.1297 17.9875 13.1297 17.5316 13.4109 17.2504L17.9418 12.7195H4.32001C3.92236 12.7195 3.60001 12.3972 3.60001 11.9995C3.60001 11.6019 3.92236 11.2795 4.32001 11.2795H17.9418L13.4109 6.74865C13.1297 6.46747 13.1297 6.01159 13.4109 5.73041Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowRight.7fe37b7a.svg";
export { ForwardRef as ReactComponent };